import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { branch, renderComponent } from 'recompose'
import Avatar from 'react-toolbox/lib/avatar'

import styles from './styles.scss'

const UserItem = ({ image, name }) => {
  return (
    <Flex align='center' styleName='userItemContainer'>
      <div styleName='userItemAvatar'>
        <Avatar image={ image }/>
      </div>
      <div styleName='userItemName'>{ name }</div>
    </Flex>
  )
}

const UserItemNoAvatar = ({ name }) => {
  return (
    <Flex align='center' styleName='userItemContainer'>
      <div styleName='userItemAvatar'/>
      <div styleName='userItemName'>{ name }</div>
    </Flex>
  )
}

const withStyle = CSSModules(styles)
export default branch(
  ({ image }) => !image,
  renderComponent(withStyle(UserItemNoAvatar))
)(withStyle(UserItem))
